import React from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Link,
    Divider,
    Stack
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const DesktopFooter = () => {
    const currentYear = new Date().getFullYear();

    const footerSections = [
        {
            title: 'サービス',
            links: [
                { text: '物件検索', path: '/room-search' },
                { text: 'ルームメイト検索', path: '/renters' },
                { text: '物件掲載', path: '/create-listing' },
                { text: 'メッセージ', path: '/messages' }
            ]
        },
        {
            title: 'サポート',
            links: [
                { text: 'ヘルプセンター', path: '/help' },
                { text: 'お問い合わせ', path: '/contact' },
                { text: 'ガイド', path: '/guide' },
                { text: 'ブログ', path: '/blog' }
            ]
        }
    ];

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f8fafc',
                color: '#475569',
                pt: 3,
                pb: 2,
                mt: 'auto',
                display: { xs: 'none', md: 'block' },
                position: 'relative',
                borderTop: '1px solid #e2e8f0',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '2px',
                    background: 'linear-gradient(90deg, #3498db, #5dade2, #4ecdc4)',
                    opacity: 0.6
                }
            }}
        >
            <Container maxWidth="lg">
                {/* メインフッターコンテンツ */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Grid container spacing={4} sx={{ maxWidth: '500px' }}>
                        {/* ブランドセクション */}
                        <Grid item xs={12} sx={{ textAlign: 'center', mb: 1 }}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    background: 'linear-gradient(135deg, #3498db 0%, #5dade2 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    mb: 0.5,
                                    fontSize: '1.2rem'
                                }}
                            >
                                ROOM SHARE MATCHING
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#64748b',
                                    lineHeight: 1.4,
                                    fontSize: '0.8rem'
                                }}
                            >
                                理想のルームシェア相手を見つけるためのマッチングプラットフォーム
                            </Typography>
                        </Grid>

                        {/* リンクセクション */}
                        {footerSections.map((section, index) => (
                            <Grid item xs={6} key={index} sx={{ textAlign: 'center' }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        mb: 1,
                                        color: '#475569',
                                        fontSize: '0.9rem'
                                    }}
                                >
                                    {section.title}
                                </Typography>
                                <Stack spacing={0.8} sx={{ alignItems: 'center' }}>
                                    {section.links.map((link, linkIndex) => (
                                        <Link
                                            key={linkIndex}
                                            component={RouterLink}
                                            to={link.path}
                                            sx={{
                                                color: '#64748b',
                                                textDecoration: 'none',
                                                fontSize: '0.8rem',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    color: '#3498db',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            {link.text}
                                        </Link>
                                    ))}
                                </Stack>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                <Divider sx={{ borderColor: '#e2e8f0', mb: 1.5 }} />

                {/* ボトムセクション */}
                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#94a3b8',
                            fontSize: '0.75rem'
                        }}
                    >
                        © {currentYear} Room Share Matching. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default DesktopFooter; 